import { render, staticRenderFns } from "./StatsUser.vue?vue&type=template&id=9133015c&"
import script from "./StatsUser.vue?vue&type=script&lang=js&"
export * from "./StatsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports